import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const EmptySize = styled.div`
  opacity: 0.2;
`
export const ModalTitle = styled.h5`
  margin: 0;
  font-family: ${theme.typography.family.bold};
  font-size: ${theme.typography.sizes['2md']};
  color: ${theme.colors.neutral.black};
`

export const SummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xm};
  justify-content: space-between;
`

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.lg};
`

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
`
